import { type PortableTextComponentProps } from '@portabletext/react'

import { type SanityFrameBuilderImage } from '../../../data/sanity/queries/types/image'

import Photo from '../photo'

type FigureValue = SanityFrameBuilderImage

const Figure = ({ value }: PortableTextComponentProps<FigureValue>) => {
  return <Photo image={value} />
}

export default Figure
